import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_dark from "@amcharts/amcharts4/themes/dark.js";
import locale from "@amcharts/amcharts4/lang/pt_BR.js";
import ContentCard from "../../common/template/contentCard";
import ContentCardBody from "../../common/template/contentCardBody";
import { montarGraficoHorizontalBar } from "../../common/graficos/montarGraficoHorizontalBar.js";

export function GraficoCustoPorUnidadeAcumuladoAno(props) {
    const cores = [am4core.color("#00d7fd"), am4core.color("#3b3bff"), am4core.color("#84f3ff"), am4core.color("#0dcf9f"), am4core.color("#0effc3")];
    const [graficoCustoPorUnidadeAcumuladoAno, setGraficoCustoPorUnidadeAcumuladoAno] = useState(null);

    useEffect(() => {
        const listaBarrasHorizontais = [...props.listaGraficoCustoPorUnidadeAcumuladoAno].sort((a, b) => a.valor - b.valor);
        const graficoCustoPorUnidadeAcumuladoAnoAtualizado = montarGraficoHorizontalBar({
            component: graficoCustoPorUnidadeAcumuladoAno,
            chartDivId: "graficoCustoPorUnidadeAcumuladoAno",
            category: "agrupador",
            value: "valor",
            bullet: "valor",
            bulletPosition: "auto",
            bulletColor: "#fff",
            bulletColorIn: "#fff",
            lista: listaBarrasHorizontais,
            prefixo: "R$",
            sufixo: "",
            maxWidthLabel: 200,
            wrapTextLabel: true,
            cores,
        });

        if (!graficoCustoPorUnidadeAcumuladoAno) {
            setGraficoCustoPorUnidadeAcumuladoAno(graficoCustoPorUnidadeAcumuladoAnoAtualizado);
        }
        return () => {
            if (graficoCustoPorUnidadeAcumuladoAno) graficoCustoPorUnidadeAcumuladoAno.dispose();
        };
    });

    am4core.useTheme(am4themes_dark);

    let listaAnual = [];
    props.listaGraficoCustoAnual.forEach((item) => {
        item.anos.forEach((itemAno) => {
            if (listaAnual.filter((serie) => serie.category == itemAno.ano).length == 0) {
                listaAnual.push({
                    category: String(itemAno.ano),
                    value: 0,
                });
            }
            listaAnual = listaAnual.map((serie) => {
                if (serie.category == itemAno.ano) {
                    return {
                        ...serie,
                        value: serie.value + (itemAno.valor == "NaN" ? 0 : itemAno.valor),
                    };
                } else {
                    return serie;
                }
            });
        });
    });

    listaAnual.sort((a, b) => {
        return a.category == "Início" ? -1 : b.category == "Início" ? 1 : a.category < b.category ? -1 : 1;
    });

    // Define cor diferente para a última coluna
    if (listaAnual.length > 0) {
        listaAnual[listaAnual.length - 1].color = am4core.color("#FF4081"); // rosa vibrante, por exemplo
    }
    const itemAnoAtual = listaAnual.find((item) => item.category == new Date().getFullYear()) || {};
    const corAnoAtual = (itemAnoAtual.color && itemAnoAtual.color.hex) || "#FFF";

    return (
        <>
            <ContentCard style={{ backgroundColor: "#30303d", color: "#fff", paddingBlock: 15 }}>
                <ContentCardBody
                    padding="0"
                    style={{
                        backgroundColor: "#30303d",
                        height: 512,
                        overflowX: "hidden",
                        overflowY: "scroll",
                    }}
                >
                    <div style={{ width: "100%", textAlign: "center", padding: 12, fontSize: "1rem" }}>
                        Custo Acumulado por UC em{" "}
                        <span style={{ color: corAnoAtual, textDecoration: corAnoAtual !== "#FFF" ? "underline" : "none" }}>{new Date().getFullYear()}</span> (R$)
                    </div>
                    <div
                        id="graficoCustoPorUnidadeAcumuladoAno"
                        style={{
                            width: "100%",
                            height: (props.listaGraficoCustoPorUnidadeAcumuladoAno || []).length * 50 < 480 ? 480 : props.listaGraficoCustoPorUnidadeAcumuladoAno.length * 50,
                        }}
                    ></div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ backgroundColor: "#30303d", color: "#fff", height: "100%" }}></ContentCard>
        </>
    );
}
